import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import FolderList from '@/library/FolderList.vue'
import * as constants from '@/library/library_constants'
const ComponentLib = () => import('@/componentlibrary/ComponentLib.vue')
const LibraryFolder = () => import('@/library/LibraryFolder.vue')
const ViewOnlyLibraryFolder = () => import('@/library/ViewOnlyLibraryFolder.vue')
const RecentlySaved = () => import('@/library/recently_saved/RecentlySaved.vue')
const RecentlyViewed = () => import('@/library/recently_viewed/RecentlyViewed.vue')
const PresentlevelsContainer = () => import('@/presentlevels/PresentlevelsContainer.vue')
const PresentlevelsSummaries = () => import('@/presentlevels/PresentlevelsSummaries.vue')
const PresentlevelsSessionWrapper = () => import('@/presentlevels/PresentlevelsSessionWrapper.vue')
const PresentlevelsNewSessionForm = () => import('@/presentlevels/PresentlevelsNewSessionForm.vue')
const PresentlevelsSavedSummaryWrapper = () => import('@/presentlevels/PresentlevelsSavedSummaryWrapper.vue')
const PresentlevelsSavedSummary = () => import('@/presentlevels/PresentlevelsSavedSummary.vue')
const {LIBRARY_MODE_ALL, LIBRARY_MODE_ARCHIVED, LIBRARY_MODE_OWNED, LIBRARY_MODE_SHARED} = constants

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_ROUTER_BASE),
  routes: [
    {
      path: '/toolkit-vue3-spa',
      name: 'home',
      component: HomeView,
      meta: {
        title: 'Engineer Landing',
      }
    },
    {
      path: '/components',
      name: 'ComponentLib',
      component: ComponentLib,
      meta: {
        title: 'Component Library',
        requiresAuth: true,
        adminAccess: true
      }
    },
    {
      path: '/share/folder/:shareToken',
      name: 'ViewOnlyLibraryFolder',
      component: ViewOnlyLibraryFolder,
      props: true,
      meta: {
        title: 'Shared Folder',
        requiresAuth: false
      }
    },
    {
      path: '/library/all',
      name: 'AllFolders',
      component: FolderList,
      props: {
        mode: LIBRARY_MODE_ALL
      },
      meta: {
        title: 'All Folders',
        requiresAuth: true,
        requiresReloginCheck: true,
        noIndex: true
      }
    },
    {
      path: '/library',
      name: 'Library',
      redirect: '/library/all'
    },
    {
      path: '/library/folder/:uuid',
      redirect: (to) => { return { path: `/folder/${to.params.uuid}` } }
    },
    {
      path: '/folder/:uuid',
      name: 'LibraryFolder',
      component: LibraryFolder,
      props: true,
      meta: {
        title: 'Library',
        requiresAuth: true,
        requiresReloginCheck: true,
        noIndex: true
      }
    },
    {
      path: '/library/recently_saved',
      name: 'RecentlySaved',
      component: RecentlySaved,
      meta: {
        title: 'Recently Saved',
        requiresAuth: true,
        requiresReloginCheck: true,
        noIndex: true,
        isPremium: true
      }
    },
    {
      path: '/library/allresources',
      redirect: '/library/recently_saved'
    },
    {
      path: '/library/archived',
      name: 'ArchivedFolders',
      component: FolderList,
      props: {
        mode: LIBRARY_MODE_ARCHIVED
      },
      meta: {
        title: 'Archived Folders',
        requiresAuth: true,
        requiresReloginCheck: true,
        noIndex: true,
        isPremium: true
      }
    },
    {
      path: '/library/recently_viewed/:type',
      name: 'RecentlyViewed',
      props: true,
      component: RecentlyViewed,
      meta: {
        title: 'Recently Viewed',
        requiresAuth: true,
        noIndex: true
      }
    },
    {
      path: '/library/shared',
      name: 'SharedWithMe',
      component: FolderList,
      props: {
        mode: LIBRARY_MODE_SHARED
      },
      meta: {
        title: 'All Folders: Shared with Me',
        requiresAuth: true,
        requiresReloginCheck: true,
        noIndex: true,
        isPremium: true
      }
    },
    {
      path: '/library/owned',
      name: 'MyFolders',
      component: FolderList,
      props: {
        mode: LIBRARY_MODE_OWNED
      },
      meta: {
        title: 'All Folders: My Folders',
        requiresAuth: true,
        requiresReloginCheck: true,
        noIndex: true,
        isPremium: true
      },
    },
    {
      path: '/presentlevels/v2',
      name: 'Presentlevels',
      component: PresentlevelsContainer,
      meta: {
        title: 'Present Levels Wizard',
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: 'PresentlevelsSessionWrapper',
          component: PresentlevelsSessionWrapper,
          meta: {
            title: 'Present Levels Wizard',
            requiresAuth: true,
          },
          children: [
            {
              path: 'session',
              name: 'PresentlevelsSession',
              meta: {
                title: 'Present Levels Wizard',
                requiresAuth: true,
              },
              children: [
                {
                  path: '',
                  name: 'PresentlevelsNewSession',
                  component: PresentlevelsNewSessionForm,
                  meta: {
                    title: 'Present Levels Wizard',
                    requiresAuth: true,
                  }
                },
                {
                  path: ':session_uuid',
                  name: 'PresentlevelsCurrentSession',
                  component: PresentlevelsSummaries,
                  props: true,
                  meta: {
                    title: 'Present Levels Wizard',
                    requiresAuth: true,
                  }
                }
              ]
            }
          ]
        },
        {
          path: 'summary',
          name: 'PresentlevelsSavedSummaryWrapper',
          component: PresentlevelsSavedSummaryWrapper,
          meta: {
            title: 'Present Levels Wizard',
            requiresAuth: true,
          },
          children: [
            {
              path: ':summary_uuid',
              name: 'PresentlevelsSavedSummary',
              component: PresentlevelsSavedSummary,
              props: true,
              meta: {
                title: 'Present Levels Wizard',
                requiresAuth: true,
              }
            }
          ]
        }
      ]
    },
  ]
})

import { authRouteGuard, reloginRouteGuard, betaRouteGuard, premiumRouteGuard } from "@/router/auth_guards.ts";
import { useRouterStore } from './router.store'


router.beforeEach(authRouteGuard)
router.beforeEach(reloginRouteGuard)
router.beforeEach(betaRouteGuard)

router.beforeEach((to, from, next) => {
  const routerStore = useRouterStore()
  if (!to.meta.isPremium) {
    routerStore.markLastNonPremiumPage(to)
  }
  next()
})

router.beforeEach(premiumRouteGuard)

router.afterEach((to) => {
  setTitle(to.meta.title)
})

export function setTitle(title: string) {
  document.title = `${title} - Goalbook Toolkit`
}

export default router
